<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <!-- <c-form-item type="input" label="商家账号" name="user_name"></c-form-item> -->
                    <c-form-item type="input" label="商家名称" name="company_name"></c-form-item>
                    <c-form-item type="input" label="店铺名称" name="shop_name"></c-form-item>
                    <c-form-item type="select" label="商家角色" name="auth_id" options="STANTIONED_AUTH"></c-form-item>
                    <!-- <c-form-item type="select" label="运营模式" name="operation_mode" :options="operationModeOptions"></c-form-item> -->
                    <c-form-item type="checkbox" label="商家状态" name="state" :options="stateType"></c-form-item>
                    <c-form-item type="checkbox" label="账号状态" name="account_state" :options="accountStateType"></c-form-item>
                </c-form>
            </m-search>
			
            <m-operate>
                <c-button power="b_srm_stationed_user_edit" color="sys" @click="createStationed()">新增商家</c-button>
<!--
                <c-button power="b_srm_stationed_user_edit" color="sys" @click="editSupportProductClassify()">批量设置可用类目</c-button>
-->
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
            <c-table ref="table" >
                <c-table-column type="selector"></c-table-column>

                <c-table-column  label="商家名称" name="company_name"  width="180">
                </c-table-column>
                <c-table-column label="商家角色"  name="auth_name" width="150">
                </c-table-column>
                <c-table-column label="平台盈利模式" name="platform_profit_model" width="260">
                  <template v-slot="{data}">
                    <span v-if="data.platform_profit_model == 1">向商家收取服务费，收取比例：<a class="s-link" @click="setProfit(data)">{{data.service_fee_ratio}}%</a></span>
                    <span v-if="data.platform_profit_model == 2">加价销售，加价比例：<a class="s-link" @click="setProfit(data)">{{data.markup_ratio}}%</a></span>
                  </template>
                </c-table-column>
				
				<c-table-column label="保证金额度" name="deposit_money" width="100">
				  <template v-slot="{data}">
				    <span v-if="data.deposit_money > 0" ><a class="s-link" @click="setDeposit(data)">￥{{data.deposit_money}}</a></span>
				    <span v-else style="color:#999999"><a @click="setDeposit(data)">去设置</a></span>
				  </template>
				</c-table-column>
				
                <c-table-column label="是否开通店铺" name="is_open_shop" width="120">
                  <template v-slot="{data}">
                    <span v-if="data.is_open_shop == 1" style="color:#999999">无店铺</span>
                    <span v-if="data.is_open_shop == 2">开通店铺</span>
                  </template>
                </c-table-column>

                <c-table-column label="店铺名称"  name="shop_name" width="180">
                  <template v-slot="{data}">
                    <span v-if="data.is_open_shop == 1">--</span>
                    <span v-if="data.is_open_shop == 2">{{data.shop_name}}</span>
                  </template>
                </c-table-column>
				
                <c-table-column label="发货地址" name="state" width="150">
                    <template v-slot="{data}">
                        {{data.delivery_province_name}} {{data.delivery_city_name}}
                    </template>
                </c-table-column>

                <c-table-column label="商家状态" name="state" width="80">
                    <template v-slot="{data}">
                      <span v-if="data.state == 1" style="color:red">停用</span>
                      <span v-if="data.state == 2" style="color:green">启用</span>
                    </template>
                </c-table-column>

                <c-table-column label="主账号/状态" name="account_state" width="95">
                  <template v-slot="{data}">
                    {{data.user_name}}
                    <span v-if="data.account_state == 1" style="color:red">禁用</span>
                    <span v-if="data.account_state == 2" style="color:green">启用</span>
                  </template>
                </c-table-column>

                <c-table-column label="创建时间" name="create_date" width="150">
                </c-table-column>

                <c-table-column  type="button" fixed="right" label="操作"  width="180">
                    <template v-slot="{data}">
						<c-table-button @click="view(data)">查看</c-table-button>
						<c-table-button power="b_srm_stationed_user_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_srm_stationed_user_edit" @click="editSupportProductClassify(data)">设置可用类目</c-table-button>
                        <c-table-button power="b_srm_stationed_user_edit" v-if="data.state == 2" @click="updateState(1,data)">停用商家</c-table-button>
                        <c-table-button power="b_srm_stationed_user_edit" v-if="data.state == 1" @click="updateState(2,data)">启用商家</c-table-button>
                        <c-table-button power="b_srm_stationed_user_edit" v-if="data.account_state == 2" @click="updateAccountState(1,data)">禁用账号</c-table-button>
                        <c-table-button power="b_srm_stationed_user_edit" v-if="data.account_state == 1" @click="updateAccountState(2,data)">启用账号</c-table-button>
                        <c-table-button power="b_srm_stationed_user_profit" @click="setProfit(data)">盈利设置</c-table-button>
                        <c-table-button power="b_srm_stationed_user_account" @click="setDeposit(data)">保证金设置</c-table-button>
                        <c-table-button power="b_srm_stationed_user_resetpwd" @click="resetPwd(data)" >重置密码</c-table-button>
                        <c-table-button power="b_srm_stationed_user_account_record" @click="accountRecord(data)" >资金明细</c-table-button>
                        <c-table-button power="b_srm_stationed_user_authlogin" @click="authLogin(data)" >授权登陆</c-table-button>
                    </template>
                </c-table-column>
       </c-table>
        </module>

        <c-dialog ref="stationedEdit" :title="editState ? '编辑商家' : '新增商家'" width="800" @resolve="submitStationed">
          <c-form ref="stationedForm">
            <c-form title="基本信息">
              <c-form-item type="input" label="企业名称" name="company_name" maxlength="30" required></c-form-item>
              <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50"></c-form-item>
              <c-form-item type="region" label="店铺地址"
                             province-name="delivery_province_id"
                             city-name="delivery_city_id"
                             county-name="delivery_county_id"
                             required></c-form-item>
              <c-form-item type="input" name="address" maxlength="150"></c-form-item>
			  <c-form-item type="select" label="主营类目" name="main_category" options="MAIN_CATEGORIES" required></c-form-item>
			  <c-form-item type="select" label="经营模式" name="management_model" options="MANAGEMENT_MODEL" required></c-form-item>
			  <c-form-item type="textarea" label="品牌介绍" name="shop_content" required></c-form-item>
              <c-form-item type="hidden" name="id"></c-form-item>
			  <c-form-item type="hidden" label="商家类型" name="stationed_type" value="1"></c-form-item>
          </c-form>
            <c-form title="配置信息" unit-width="100%">
                <c-form-item type="select" label="商家角色" name="auth_id" options="STANTIONED_AUTH" required></c-form-item>
                <c-form-item type="radio"  label="清分方式" v-model="liquidationType"  name="liquidation_type" :options="liquidationTypeOptions"  :word="liquidationTypeWord" required></c-form-item>
                <c-form-item type="number" label="清分延迟时间" :limit="[0,100]" name="liquidation_date"
                         required input-unit="天" word="清分将在满足条件（发货或者确认收货）后再延期X天进行"></c-form-item>
                <c-form-item v-show="editState" type="radio" label="商家状态" name="state" v-model="stationedState" :options="stateType" required></c-form-item>
          </c-form>
          </c-form>
        </c-dialog>
		
		<c-dialog ref="stationedView" title="商家详情" width="800" :button="false">
		  <c-form ref="stationedFormView">
		    <c-form title="基本信息">
		      <c-form-item type="input" label="企业名称" name="company_name" maxlength="30" required disabled></c-form-item>
		      <c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" disabled></c-form-item>
		      <c-form-item type="input" label="店铺地址" name="address" maxlength="100" required disabled></c-form-item>
			  <c-form-item type="select" label="主营类目" name="main_category" options="MAIN_CATEGORIES" required disabled></c-form-item>
			  <c-form-item type="select" label="经营模式" name="management_model" options="MANAGEMENT_MODEL" required disabled></c-form-item>
			  <c-form-item type="textarea" label="品牌介绍" name="shop_content" required disabled></c-form-item>
		      <c-form-item type="hidden" name="id"></c-form-item>
		  </c-form>
		  <c-form title="配置信息">
            <c-form-item type="select" label="商家角色" name="auth_id" options="STANTIONED_AUTH" required disabled></c-form-item>
			<c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationTypeOptions" required disabled></c-form-item>
			<div style="display:inline-block">
				<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" style="float:left" required disabled></c-form-item>
				<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">天</div>
			</div>
		    <c-form-item type="radio" label="商家状态" name="state" :options="stateType" required disabled></c-form-item>
		  </c-form>
		  </c-form>
		</c-dialog>

        <c-dialog ref="profitEdit" title="盈利设置" width="400" @resolve="submitProfit">
        <c-form ref="profitForm">
          <div v-if="platformProfitModel == 1" >
			<c-form-item type="number" decimal="2" :limit="[0,99]"  label="服务费比例" name="service_fee_ratio" required style="float:left"></c-form-item>
			<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">%</div>
          </div>
		  <div v-if="platformProfitModel == 2" >
			<c-form-item type="number" decimal="2" :limit="[0,99]"  label="加价比例" name="markup_ratio" required style="float:left"></c-form-item>
			<div style="float: left; height: 38px;display: flex;align-items: center;margin-left:5px;">%</div>
		  </div>
          <c-form-item type="hidden" name="id"></c-form-item>
        </c-form>
      </c-dialog>

        <c-dialog ref="depositEdit" title="保证金设置" width="400" @resolve="submitDeposit">
        <c-form ref="depositForm">
          <c-form-item type="input" label="保证金金额" name="deposit_money" required></c-form-item>
          <c-form-item type="hidden" name="id"></c-form-item>
        </c-form>
      </c-dialog>

        <edit-product-classify ref="editProductClassify" @resolve="$refs.table.update()"></edit-product-classify>
    </page>
</template>

<script>
    import editProductClassify from '@/pages/product/stationed_product_classify.vue'
    import {mapState} from "vuex";

    export default {
        name: 'm_srm_stationed_user',

        components: {
            editProductClassify
        },
        data() {
            return {
              workType:26,
              searchParams:{},
              operationMode: 0,
              operationModeOptions: [{
                  name: '平台运营',
                  value: 1
              },{
                  name: '商家自营',
                  value: 2
              }],
              settlementAccountType: [{
                name: '平台统收账户',
                value: 1
              },{
                name: '商家独立账户',
                value: 2
              }],
              stationedState:2,
              stateType:[
                  {name:'启用',value:2},
                  {name:'停用',value:1}
              ],
              accountStateType:[
                  {name:'启用',value:2},
                  {name:'禁用',value:1}
              ],
              liquidationType:1,
              liquidationTypeOptions:[
                  {name:'发货清分',value:1},
                  {name:'确认收货清分',value:2}
              ],
              editState: true,
              platformProfitModel: 1
            }
        },
		
		computed: {
            ...mapState(['systemConfig', 'userInfo']),

            liquidationTypeWord() {
                return {
                    1: '订单商品发货后，达到清分条件；将根据订单的发货数量进行清分，发多少清多少。',
                    2: '订单确认收货后，达到清分条件；根据确认收货的有效商品（未发生售后）进行清分。'
                }[this.liquidationType]
            }
		},
		
		watch: {
		},

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data = {}) {
                data.stationed_type = 1;
                this.$refs.table.load({
                    url: '/stationed/list',
                    data
                });
                this.searchParams = data;
            },

            createStationed() {
                this.editState = false;
                this.$refs.stationedForm.clear();
                this.$refs.stationedForm.set({
                    stationed_type:1,
                    liquidation_type:1,
                    state:2
                });
                this.$refs.stationedEdit.open();
            },
            edit(val) {
                this.editState = true;
                this.$refs.stationedForm.clear();
                this.$refs.stationedForm.set(val);
                this.$refs.stationedEdit.open();
            },
            view(val) {
                this.editState = true;
                this.$refs.stationedFormView.clear();
                val.address = val.delivery_province_name+','+val.delivery_city_name+','+val.delivery_county_name+','+val.address;
                this.$refs.stationedFormView.set(val);
                this.$refs.stationedView.open();
            },

            setProfit(val) {
                this.platformProfitModel = val.platform_profit_model;
                this.$refs.profitForm.set(val);
                this.$refs.profitEdit.open();
            },

            setDeposit(val) {
                this.$refs.depositForm.set(val);
                this.$refs.depositEdit.open();
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'停用')+'【'+val.company_name+'】商家吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/stationed/update_state',
                            data: {stationed_id:val.id, state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            updateAccountState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'商家【'+val.company_name+'】的主登陆账号吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/sys_user/update_state',
                            data: {id:val.user_id, state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            submitStationed(stop) {
                stop();
                this.$refs.stationedForm.submit({
                  url: this.editState ? '/stationed/edit' : '/stationed/add',
                  rule: {
                      company_name: '请填写企业名称',
                      delivery_county_id: '请选择店铺地址所在省市县信息',
                      address: '请填写店铺详细地址',
                      main_category: '请填写商家主营类目',
                      management_model: '请填写经营模式',
                      shop_content: '请填写商家品牌介绍',
                      auth_id: '请选择商家角色',
                      liquidation_type: '请选择清分方式',
                      liquidation_date: '请输入清分延迟时间'
                  },
                  dataFormatter: data => {
                      data.platform_type = 2;
                      data.state = this.stationedState;
                      return data;
                  },
                  success: (data, res, msg) => {
                    if (this.editState){
                        this.$message({
                            text: msg,
                            icon: 'success'
                        });
                    }else {
                        this.$confirm({
                            text: msg,  // 提示内容,
                            buttonName: '知道了',  // 确定按钮文字
                            cancelButton: false  // 是否显示取消按钮
                        });
                    }
                    this.$refs.table.update();
                    this.$refs.stationedEdit.close();
                  }
                });
            },

            submitDeposit(stop) {
                stop();
                this.$refs.depositForm.submit({
                  url: '/stationed/account/deposit/set',
                  rule: {
                    deposit_money: '请填写保证金金额'
                  },
                  dataFormatter: data => {
                    data.stationed_id = data.id;
                    return data;
                  },
                  success: (data, res) => {
                    this.$message({
                      text: '保存成功'
                    });
                    this.$refs.table.update();
                    this.$refs.depositEdit.close();
                  }
                });
            },

            submitProfit(stop) {
                stop();
                this.$refs.profitForm.submit({
                  url: '/stationed/profit/set',
                  rule: {
                    markup_ratio: [{
                      type: 'empty',
                      word: '请填平台销售默认加价比例',
                      skip: () => {
                        return this.platformProfitModel == 1;
                      }
                    }],
                    service_fee_ratio: [{
                      type: 'empty',
                      word: '请填写商家服务费收取比例',
                      skip: () => {
                        return this.platformProfitModel == 2;
                      }
                    }]
                  },
                  dataFormatter: data => {
                    data.stationed_id = data.id;
                    return data;
                  },
                  success: (data, res) => {
                    this.$message({
                      text: '保存成功'
                    });
                    this.$refs.table.update();
                    this.$refs.profitEdit.close();
                  }
                });
            },

            resetPwd(val) {
                this.$confirm({
                  text: '确定要重置商家【'+val.company_name+'】的密码吗？',  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: true,  // 是否显示取消按钮
                  resolve: () => {
                    this.request({
                      url: '/sys_user/reset_pwd',
                      data: {id:val.user_id},
                      loading: true,
                      success: data => {
                          this.$confirm({
                            text: data,  // 提示内容,
                            buttonName: '知道了',  // 确定按钮文字
                            cancelButton: false  // 是否显示取消按钮
                          });
                      }
                    });
                  },  // 确定按钮回调
                  cancel: () => {},  // 取消按钮回调
                });
            },

            accountRecord(val){
              this.navigateTo({
                path: '/stationed_account_record',
                query: {
                    stationed_id: val.id,
                    company_name: val.company_name
                }
              });
            },
            authLogin(val){
                this.request({
                url: '/stationed/user/getAuthUrl',
                data: {
                    company_name:val.company_name,
                    id: val.id,
                },
                loading: true,
                success: data => {
                    window.open(data);
                }
            });
            },
            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            },
            /**
             * 设置商家可用的商品类目
             * @param item
             */
            editSupportProductClassify(item) {
                var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');

                this.$refs.editProductClassify.open(Array.from(list, item => item.data.id));
            }
        }
    }
</script>